import DeleteQuotation from "@/v2/api/quotation/Delete";
import DeleteButton from "../general/Delete";

export default function QuotationsDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["quotations"]}
            deleteFn={DeleteQuotation}
            title="Delete Quotation"
            description="Are you sure you want to delete this quotation? This action cannot be undone. Click delete to confirm."
            successTitle="Quotation Deleted Successfully"
            isInside={isInside}
        />
    );
}
